<template>
  <div>
    <the-banner :data="banner" />
    <the-bar />
    <the-games :data="games" />
    <the-contact />
  </div>
</template>

<script>
import Vue from "vue";
import { Lazyload } from "vant";
import TheBanner from "./modules/TheBanner";
import TheBar from "./modules/TheBar";
import TheGames from "./modules/TheGames";
import TheContact from "./modules/TheContact";
import { homeinfo } from "@/http/cms";
import { version } from "../../../package.json";

Vue.use(Lazyload);

export default {
  name: "Home",
  components: { TheBanner, TheBar, TheGames, TheContact },
  data() {
    return {
      banner: [],
      games: {}
    };
  },
  mounted() {
    this.fetchData();
    console.info(`
    __      __________   ________ _____________________ ____________________
   /  \\    /  \\_____  \\  \\_____  \\\\______   \\_   _____//   _____/\\__    ___/
   \\   \\/\\/   //   |   \\  /   |   \\|    |  _/|    __)_ \\_____  \\   |    |
    \\        //    |    \\/    |    \\    |   \\|        \\/        \\  |    |
     \\__/\\  / \\_______  /\\_______  /______  /_______  /_______  /  |____|
          \\/          \\/         \\/       \\/        \\/        \\/
   `);
    console.info(`version: ${version}`);
  },
  methods: {
    /**
     * @description 初始化首页信息
     */
    fetchData() {
      homeinfo().then(res => {
        if (res && res.data) {
          this.banner = res.data.banner;
          this.games = res.data.games;
        }
      });
    }
  }
};
</script>
